import {IEnvironment} from "@shared/interfaces/environment.interface";

export const environment: IEnvironment = {
  conveyKey: 'pub_9d93e33f00baeb9022566543cab6058c',
  //baseURL: 'http://localhost:8084/api/v1',
  baseURL: 'https://fraud-streaming.peaqock.com/api/v1',
  //baseURL: 'http://157.230.17.252:8070/api/v1',
  accessToken: 'jwt',
  user: 'user',
};
